module.exports = __webpack_public_path__ + "img/header-phone.42250519.jpg";